import { useEffect, useState } from 'react';

/**
 * Tracks the `.dark` class on `<html>` — the same signal the app's `dark:`
 * Tailwind variant reacts to (set by `genDsDarkModeScript` in config/app-index.ts).
 * Returns `false` on the server and on the first client render, then updates
 * once mounted and stays in sync with future class changes (e.g. a live OS
 * `prefers-color-scheme` change).
 *
 * @example
 * ```tsx
 * const isDark = useIsDarkMode();
 * ```
 */
export const useIsDarkMode = (): boolean => {
	const [isDark, setIsDark] = useState(false);

	useEffect(() => {
		const update = (): void => setIsDark(document.documentElement.classList.contains('dark'));

		update();
		const observer = new MutationObserver(update);
		observer.observe(document.documentElement, { attributeFilter: ['class'] });
		return () => observer.disconnect();
	}, []);

	return isDark;
};
